export class Constants{
    static BASE_URL = 'https://future-labs.5d-dev.com/Proxy/';
    static IsAuthenticated = false;
    static username='future_lab';
    static password='FutLab@961';
    static client_id='THIRD_PARTY';
    static client_secret='THIRD_PARTY_SECRET';
}